<template>
  <div
    class="q-my-md q-pa-md full-width"
    :class="type"
  >
    <p
      v-if="!hideText"
      class="text-overline text-uppercase q-ma-none heading"
    >
      {{ $t('info.textTitle.' + type) }}
    </p>
    <p class="q-ma-none">
      <slot />
    </p>
  </div>
</template>
<script>
export default {
  name: 'Info',

  props: {
    type: {
      type: String,
      default: 'info',
    },
    hideText: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
p.heading {
  line-height: 1.5em;
}

div.info {
  background-color: #c1f4cd;
  border-radius: 4px;
  border-width: 0 5px;
  border-style: solid;
  border-color: #21ba45;
}

div.warning {
  background-color:$red-6;
  color:white;
  border-radius: 4px;
  border-width: 0 5px;
  border-style: solid;
  border-color: $red-9;
}
</style>
